// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__19NMA","buttons":"Footer_buttons__1GzMt"};